import { on } from "delegated-events";
import { Ajax } from "../../assets/js/helpers/ajax";
import { ToastHelper } from "../../assets/js/helpers/toast";
import { Translation } from "../../assets/js/helpers/translation";
export class LoadMore {

  config = {};
  contentPot = null;
  loadMoreBtn = null;
  #loadOver = false;
  #mode = "default";


  constructor(el = null) {
    this.el = el;
    this.config = JSON.parse(this.el.dataset.config);
    this.#mode = this.config?.mode ?? 'default';
    switch( this.#mode ){
      case 'default':
        this.contentPot = this.el.querySelector("[data-content-pot]");
      break;
      case 'target':
        this.contentPot = document.querySelector(this.el.dataset.contentTarget);
      break;
    }
    this.loadMoreBtn = this.el.querySelector("[data-loadmore-btn]");
    this.init();
  }

  #cleanPot(){
    this.contentPot.innerHTML = "";
  }

  #fillPot( content, mode = "replace"){
    switch( mode ){
      case "replace":
        this.#cleanPot();
        this.contentPot.innerHTML = content;
      break;
      case "append":
        this.contentPot.innerHTML += content;
      break;
    }
  }

  #hideLoadMoreBtn(){
    this.loadMoreBtn.classList.add("d-none");
  }

  init() {
    
    on("click", "[data-js-component=LoadMore] [data-loadmore-btn]", (e) => {
      e.preventDefault();
      if( this.#loadOver ){ return; }
      let component = e.currentTarget.closest(`[data-js-component]`);
      try{
        Ajax.post(
            this.config.endPoint,
            {
              "offset" : this.el.dataset.resultOffset
            },
            "json"
        ).then( response => {
          if( response !== undefined ){
            if( response?.end == false){
              this.#fillPot(response.content, "append");
              component.dataset.resultOffset = response.offset;
            }else{
              this.#fillPot(response.content, "append");
              this.#hideLoadMoreBtn();
              this.#loadOver = true;
            }
          }else{
            ToastHelper.show(Translation.translate('zaux_loadmore_error'), 'error');
          }
        });   
      }catch(e){
        ToastHelper.show(Translation.translate('zaux_loadmore_error'), 'error');
      }
    });

  }

}
